/** Errores de licencia que detecta el registro sin preguntar al API; `AddLicenseForm` los muestra en el campo. */
export const SIGN_UP_LICENSE_ERRORS = {
  alreadyAdded: 'License already added',
  codeNotFound: 'Code not found',
  otherProfile: 'License from another profile',
  requestFailed: 'License request failed',
  withoutContent: 'License without content',
} as const;

const INVALID_LICENSE = 'Invalid license';

export type SignUpLicenseResponse = { error?: { status?: number; data?: { status?: string; error?: { code?: number; message?: string } } } } | null | undefined;

const SIGN_UP_LICENSE_ERROR_KEYS = new Map<string, string>([
  [SIGN_UP_LICENSE_ERRORS.alreadyAdded, 'signup:You already added this licence'],
  [SIGN_UP_LICENSE_ERRORS.codeNotFound, 'signup:Code not found'],
  [SIGN_UP_LICENSE_ERRORS.otherProfile, 'signup:You have a graduate with another profile'],
  [SIGN_UP_LICENSE_ERRORS.requestFailed, 'common:An error has occurred'],
  [SIGN_UP_LICENSE_ERRORS.withoutContent, 'signup:It seems that this license does not have any associated content yet'],
]);

export function getSignUpLicenseErrorKey(errorMsg?: string | null): string | null {
  return SIGN_UP_LICENSE_ERROR_KEYS.get(errorMsg ?? '') ?? null;
}

/** Sin mensaje del API, un 404 es un código que no existe; un 500 o un fallo de red (`{ error: undefined }`), no. */
export function getSignUpLicenseErrorMsg(response: SignUpLicenseResponse): string {
  const apiError = response?.error?.data?.error;
  if (apiError?.message) return apiError.message;
  return apiError?.code === 404 ? INVALID_LICENSE : SIGN_UP_LICENSE_ERRORS.requestFailed;
}
